import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { CaseService } from "@js/services/CaseService";
import { RoleService } from "@js/services/RoleService";
import {
  AddressLookupDTO,
  BuildProcurementTypeEnum,
  Case,
  CaseAccessLevelEnum,
  CaseClient,
  CaseCrudClient,
  CaseMember,
  CaseMemberClient,
  DevelopmentInput,
  DevelopmentInputClient,
  ExitStrategyEnum,
  FileAttachment,
  FileAttachmentClient,
  FileAttachmentCrudClient,
  LenderResultClient,
  LenderResultMinimalDTO,
  ModuleEnum,
  OwnNewDevelopmentEnum,
  PlanningPermissionTypeEnum,
  PlanningResponsibilityEnum,
  PostalAddress,
  Product,
  ProjectOwnership,
  ProjectOwnershipClient,
  PurchaseProcessTypeEnum,
  StreetAddressClient,
  UserClient,
} from "@src/apis/ModularClient";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs";
import { UserService } from "@js/services/UserService";
import { Expand } from "@ccq/ts-lib";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class CaseOverviewController {
  dataLoading: boolean = false;

  //Applicants displayed
  shareholders: CaseMember[];
  currentApplicant: CaseMember;
  applicantForm: ng.IFormController;
  addEditApplicant: CaseMember;
  confirmDeleteApplicant: CaseMember;
  tempApplicant: CaseMember;
  showQuickEditModal: boolean = false;
  showDelete: boolean = false;
  confirmationDelete: boolean = false;
  maxDateOfBirth: Date = new Date();
  minDateOfBirth: Date = new Date("Jan 01 1900");
  maxDateForDateField: Date = new Date("Jan 01 3000");
  message: string = "";
  modal: boolean = false;
  disableQuickEditSave: boolean = false;
  isAddShareholder: boolean;

  isAdmin: boolean;
  isBroker: boolean;
  shareholder: CaseMember;
  isPrimaryApplicant: boolean;

  //Open / close the sections
  ownership: boolean = false;
  siteDetails: boolean = false;
  planning: boolean = false;
  procurement: boolean = false;
  deposit: boolean = false;
  guarantees: boolean = false;
  exitStrategy: boolean = false;
  completion: boolean = false;
  mezzanine: boolean = false;
  preferences: boolean = false;
  existingRelationships: boolean = false;
  caseOverview: boolean = false;
  isExpanded: boolean = false;
  executiveSummary: boolean = false;

  //File Section

  thisModuleSection: ModuleEnum.Planning;
  fileUpload: Expand<FileAttachment>[];
  fileUploadPlaning: FileAttachment[];
  fileUploadTeam: FileAttachment[];
  fileUploadProperties: FileAttachment[];
  selectedProduct: Product;
  selectedResult: LenderResultMinimalDTO;
  total: number = 0;
  openModal: boolean = false;
  uploadingFiles: FileUploadProgressDTO[];
  renamingFile: FileAttachment;

  //Case info
  loanCriteria: DevelopmentInput;
  dateOfOrigPurchMonth: number;
  dateOfOrigPurchYear: number;
  case: Expand<
    Case,
    {
      readonly attachments: true;
      readonly developmentInput: true;
    }
  >;
  //Search address
  searchresults: string;
  PostCodeOptions: PostalAddress[] = [];
  searchterm: string;
  searchingForAddress: boolean = false;

  //Development Experience info
  companyDetails: ProjectOwnership;

  tinymceOptions: any;
  multiPartForm1: ng.IFormController;
  showAutofill: boolean;

  static $inject = [
    "$rootScope",
    "$routeParams",
    "CaseMemberClient",
    "CaseService",
    "CaseClient",
    "DevelopmentInputClient",
    "$location",
    "StreetAddressClient",
    "$q",
    "LenderResultClient",
    "ProjectOwnershipClient",
    "FileAttachmentClient",
    "FileAttachmentHelper",
    "$window",
    "RoleService",
    "UserService",
    "UserClient",
    "DealFileAttachmentHelper",
    "CaseCrudClient",
    "ODataHelper",
    "FileAttachmentCrudClient",
  ];

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private $caseMemberClient: CaseMemberClient,
    private caseService: CaseService,
    private caseClient: CaseClient,
    private developmentInputClient: DevelopmentInputClient,
    private $location: ng.ILocationService,
    private streetAddressClient: StreetAddressClient,
    protected $q: ng.IQService,
    private lenderResultClient: LenderResultClient,
    private projectOwnershipClient: ProjectOwnershipClient,
    private fileAttachmentClient: FileAttachmentClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private $window: ng.IWindowService,
    private roleService: RoleService,
    private userService: UserService,
    private userClient: UserClient,
    private dealFileAttachmentHelper: DealFileAttachmentHelper,
    private caseCrudClient: CaseCrudClient,
    private odataHelper: ODataHelper,
    private fileAttachmentCrudClient: FileAttachmentCrudClient,
  ) {
    this.tinymceOptions = {
      content_style: "body {color: #304b9a;font:300 13.33px Roboto,sans-serif;}",
      menubar: false,
      height: 300,
      branding: false,
      statusbar: false,
      plugins: [
        "advlist autolink lists link image charmap print preview anchor",
        "searchreplace visualblocks code fullscreen",
        "insertdatetime media table paste code help wordcount",
      ],
      toolbar:
        "undo redo | formatselect | " +
        "bold italic backcolor forecolor | alignleft aligncenter " +
        "alignright alignjustify | bullist numlist outdent indent | preview fullscreen |" +
        "removeformat | help",
    };

    this.userClient.getCurrentUserAutofill().then((response) => {
      this.showAutofill = response;
    });

    if (this.$routeParams.CaseId) {
      this.dataLoading = true;

      //case is needed to get loanCriteria information
      this.odataHelper
        .getOne(this.caseCrudClient, {
          filter: {
            id: {
              eq: Number(this.$routeParams.CaseId),
            },
          },
          expand: {
            developmentInput: true,
          },
        })
        .then((response) => {
          this.odataHelper
            .getMany(this.fileAttachmentCrudClient, {
              filter: {
                caseId: {
                  eq: Number(this.$routeParams.CaseId),
                },
              },
            })
            .then((attachments) => {
              this.case = response as typeof response & { attachments: any[] };
              this.case.attachments = attachments;

              if (this.$routeParams.Planning) {
                this.planning = true;
              }

              if (this.case) {
                this.fileUpload = this.case.attachments;

                this.projectOwnershipClient.fetch(this.case.developmentExperienceId).then((response) => {
                  this.companyDetails = response;
                });

                this.developmentInputClient
                  .fetch(this.case.developmentInputId)
                  .then((response) => {
                    this.loanCriteria = response;

                    if (this.loanCriteria) {
                      if (this.loanCriteria.cI_Dev_DateOfOrigPurch) {
                        this.dateOfOrigPurchMonth = this.loanCriteria.cI_Dev_DateOfOrigPurch.getMonth() + 1;
                        this.dateOfOrigPurchYear = this.loanCriteria.cI_Dev_DateOfOrigPurch.getFullYear() % 100;
                      }
                      if (!this.loanCriteria.dI_PurchaseAgentFees) {
                        this.loanCriteria.dI_PurchaseAgentFees = 0;
                      }
                      if (!this.loanCriteria.dI_PurchaseLegalFees) {
                        this.loanCriteria.dI_PurchaseLegalFees = 0;
                      }
                      if (!this.loanCriteria.dI_PurchaseOtherFees) {
                        this.loanCriteria.dI_PurchaseOtherFees = 0;
                      }
                    } else {
                      // If there's no loan criteria then something has gone wrong
                      this.$location.path("/dashboard");
                    }
                  })
                  .catch((error) => {
                    this.$location.path("/dashboard");
                  })
                  .finally(() => {
                    this.dataLoading = false;
                  });
              } else {
                // If no case is returned, this could be that the logged in user has been removed from the case
                // - only do this if there is a logged in user, otherwise let the routing sort out where the redirect should go
                if ((this.$rootScope as any).selectedUser) {
                  this.$location.path("/dashboard");
                }
              }
            });
        })
        .catch((error) => {
          this.$location.path("/dashboard");
        })
        .finally(() => {
          this.dataLoading = false;
        });

      this.checkForAdmin();
      this.checkForBroker();
      this.checkForPrimaryUser();

      this.$caseMemberClient.fetchByCaseId(this.$routeParams.CaseId).then((response) => {
        this.shareholders = response;
      });
    }
  }

  checkForAdmin(): void {
    this.dataLoading = true;
    this.roleService
      .isAdminUser()
      .then((response) => {
        this.isAdmin = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkForBroker(): void {
    this.dataLoading = true;
    this.roleService
      .isBroker()
      .then((response) => {
        this.isBroker = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkForPrimaryUser(): boolean {
    if (
      (this.$rootScope as any).currentUser &&
      this.case &&
      (this.$rootScope as any).currentUser.userName == this.case.ownerUser
    ) {
      this.isPrimaryApplicant = true;
      return true;
    }

    this.isPrimaryApplicant = false;
    return false;
  }

  clientAccountAccessCheck(shareholder: CaseMember): boolean {
    if (this.shareholders) {
      this.shareholder = this.shareholders.find((x) => x.userId == shareholder.userId);
    }

    if (this.shareholder.userId == (this.$rootScope as any).currentUser.id) {
      return true;
    }

    if (this.checkForPrimaryUser()) {
      return true;
    }

    return false;
  }

  getAddressList(app, searchTerm: string) {
    let foundMatch = false;

    if (this.PostCodeOptions && this.PostCodeOptions && this.PostCodeOptions.length > 0) {
      let addressLookup = this.PostCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          app.dI_StreetAddress = address;
          this.searchterm = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.loanCriteria.dI_StreetAddress.addressLine1 = addressLookup.addressLine2.replace(
          addressLookup.addressLine2.substring(addressLookup.addressLine2.indexOf("-") - 1),
          "",
        );
        this.loanCriteria.dI_StreetAddress.addressLine2 = addressLookup.addressLine3;
        this.loanCriteria.dI_StreetAddress.addressLine3 = addressLookup.addressLine4;
        this.loanCriteria.dI_StreetAddress.addressLine4 = addressLookup.postCode;
        this.loanCriteria.dI_StreetAddress.postCode = addressLookup.addressLine1;
        this.searchterm = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.PostCodeOptions = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.PostCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  save(): ng.IPromise<number> {
    let defer = this.$q.defer<number>();
    if (!this.loanCriteria) {
      return defer.promise;
    }

    this.developmentInputClient
      .addUpdateReturnOnlyID(this.loanCriteria)
      .then((response) => {
        this.lenderResultClient
          .productsOfferingLargestLoanAndMatching(
            true,
            true,
            20,
            false,
            "",
            "",
            "",
            this.loanCriteria.searchName,
            true,
            this.loanCriteria,
          )
          .then(() => {});
        defer.resolve(response as number);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
      });

    if (this.case.completionDate) {
      const completionDate = new Date();
      completionDate.setHours(0, 0, 0, 0);
      this.case.completionDate = new Date(
        completionDate.setUTCFullYear(
          this.case.completionDate.getFullYear(),
          this.case.completionDate.getMonth(),
          this.case.completionDate.getDate(),
        ),
      );
    }
    const { attachments, developmentInput, ...onlyCase } = this.case;

    this.caseCrudClient.patch(onlyCase).then(() => {});

    this.projectOwnershipClient
      .addUpdateReturnOnlyID(this.companyDetails)
      .then((response) => {
        //set ID of selectedobject
        this.companyDetails.id = response;
        //after save take out saving assoication each time
        this.companyDetails.parentCaseToAssoicateWithOnCreation = null;
        defer.resolve(response as number);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
      });

    this.goToCaseDashboard(false);

    return defer.promise;
  }

  go(path): void {
    this.$location.path(path);
  }

  /**
   * Calculates the order number of all the preferences when one is toggled
   * @param toggledPreference
   */
  calculatePreferenceOrder(toggledPreference: string) {
    const preferenceNames = [
      "SearchPreferenceLoanSize",
      "SearchPreferencePricing",
      "SearchPreferenceCompletionSpeed",
      "SearchPreferenceCustomerService",
    ];
    // Finds the highest preference order of all preferences
    const maxPreferenceOrder = Math.max(
      this.loanCriteria.searchPreferenceCompletionSpeed,
      this.loanCriteria.searchPreferenceCustomerService,
      this.loanCriteria.searchPreferenceLoanSize,
      this.loanCriteria.searchPreferencePricing,
    );

    // If the preference that has been toggled already has a value greater than 0 then it is being turned OFF
    if (this.loanCriteria[toggledPreference] > 0) {
      // Find any preferences that have a higher preference number and decrease their order number by 1
      for (let preference of preferenceNames) {
        if (preference == toggledPreference) {
          continue;
        } else {
          if (this.loanCriteria[preference] > this.loanCriteria[toggledPreference]) {
            this.loanCriteria[preference]--;
          }
        }
      }

      this.loanCriteria[toggledPreference] = 0;
    } else {
      // Preference is being turned ON
      // Use the highest preference order number and increase by 1
      this.loanCriteria[toggledPreference] = maxPreferenceOrder + 1;
    }
  }

  goToCaseDashboard(saveChanges: boolean): void {
    if (saveChanges && !this.roleService.IsLender) {
      this.save().then((response) => {
        (this.$rootScope as any).formSaved = true;
        this.$location.path("/casedashboard/" + this.case.id);
      });
    } else {
      this.$location.path("/casedashboard/" + this.case.id);
    }
  }

  /** Initialise the CaseMember for adding a new Shareholder/Applicant */
  initialiseNewApplicant() {
    this.addEditApplicant = {
      accessLevel: CaseAccessLevelEnum.FullAccess,
      caseId: this.$routeParams.CaseId,
      isApplicant: true,
      order: this.shareholders && this.shareholders.length > 0 ? this.shareholders.length + 1 : 1,
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      } as PostalAddress,
    } as CaseMember;
  }

  deleteApplicant(): void {
    var id = this.confirmDeleteApplicant.id;

    this.$caseMemberClient.markAsDeleted(id).then((response) => {
      var index = this.shareholders
        .map(function (s) {
          return s.id;
        })
        .indexOf(id);

      //let index = this.shareholders.indexOf(this.confirmDeleteApplicant);
      this.shareholders.splice(index, 1);
    });
    this.confirmDeleteApplicant = {} as CaseMember;
    this.showDelete = false;
  }

  deleteConfirmApplicant(applicant: CaseMember) {
    this.showDelete = true;
    this.confirmDeleteApplicant = { ...applicant };
  }

  /**
   * Open the Shareholder/Applicant quick edit
   * @param applicant
   */
  openShareholderQuickEdit(applicant: CaseMember) {
    if (applicant) {
      this.isAddShareholder = false;
      this.addEditApplicant = applicant;
      this.tempApplicant = { ...this.addEditApplicant };
    } else {
      this.isAddShareholder = true;
      if (this.applicantForm) {
        this.applicantForm.$setPristine();
        this.applicantForm.$setUntouched();
      }

      this.initialiseNewApplicant();
    }

    this.showQuickEditModal = true;
  }

  /** Cancel any adding or editing of a Shareholder/Applicant */
  cancelShareholderQuickEdit() {
    if (this.tempApplicant && this.tempApplicant.id > 0) {
      this.shareholders = this.shareholders.filter((applicant) => applicant.id != this.tempApplicant.id);
      this.shareholders.push(this.tempApplicant);
    }

    this.closeShareholderQuickEdit();
  }

  /** Save a new or updated Shareholder/Applicant */
  saveApplicant(): void {
    this.disableQuickEditSave = true; // this is just because sometimes the save takes a little while and the user could click the save button again
    this.addEditApplicant.addressHistory = this.addEditApplicant.addressHistory ?? "";
    this.addEditApplicant.creditBankruptDetail = this.addEditApplicant.creditBankruptDetail ?? "";
    this.addEditApplicant.creditRefusedDetail = this.addEditApplicant.creditRefusedDetail ?? "";
    this.addEditApplicant.creditConvictionDetails = this.addEditApplicant.creditConvictionDetails ?? "";
    this.addEditApplicant.creditCcjDetail = this.addEditApplicant.creditCcjDetail ?? "";
    this.addEditApplicant.creditDefaultedDetail = this.addEditApplicant.creditDefaultedDetail ?? "";
    this.addEditApplicant.creditCcjDetail = this.addEditApplicant.creditCcjDetail ?? "";
    this.addEditApplicant.creditRepossessedDetail = this.addEditApplicant.creditRepossessedDetail ?? "";
    this.addEditApplicant.creditStepInRightsExercisedDetail =
      this.addEditApplicant.creditStepInRightsExercisedDetail ?? "";
    this.addEditApplicant.creditSanctionedDetail = this.addEditApplicant.creditSanctionedDetail ?? "";
    this.addEditApplicant.creditRelatedDetail = this.addEditApplicant.creditRelatedDetail ?? "";
    this.addEditApplicant.creditWelfareDetail = this.addEditApplicant.creditWelfareDetail ?? "";
    this.addEditApplicant.visaStatus = this.addEditApplicant.visaStatus ?? "";
    this.addEditApplicant.furtherInformation = this.addEditApplicant.furtherInformation ?? "";
    this.addEditApplicant.professionalQualifications = this.addEditApplicant.professionalQualifications ?? "";
    this.addEditApplicant.sKillsInOrder = this.addEditApplicant.sKillsInOrder ?? "";
    this.addEditApplicant.nationality = this.addEditApplicant.nationality ?? "";
    this.addEditApplicant.phoneNumber = this.addEditApplicant.phoneNumber ?? "";

    this.$caseMemberClient
      .addorUpdateCaseMember(this.isAddShareholder, this.addEditApplicant)
      .then((response) => {
        response.dateOfBirth = this.addEditApplicant.dateOfBirth; // TODO should try to parse the response.DOB as it's being returned as a string

        const existingShareholder = this.shareholders.find((s) => s.id == response.id);

        // If found then we're updating
        if (existingShareholder) {
          this.shareholders = this.shareholders.filter((member) => member.id != this.addEditApplicant.id);
          this.shareholders.push(response);
        } else {
          this.shareholders.push(response);
        }
      })
      .finally(() => {
        this.closeShareholderQuickEdit();
        this.disableQuickEditSave = false;
      });
  }

  goToApplicantDetails(applicant: CaseMember): void {
    //change applicant.id to index (use a for loop to iterate through dto)
    var applicantId;

    for (let i = 0; i <= this.shareholders.length - 1; i++) {
      if (this.shareholders[i].id == applicant.id) {
        applicantId = i;
      }
    }
    if (applicantId || applicantId == 0) {
      this.go("/applicantdetails/" + this.case.id + "/" + this.case.developmentExperienceId + "/4/" + applicantId);
    }
  }

  closeShareholderQuickEdit() {
    this.showQuickEditModal = false;
    this.applicantForm.$setPristine();
    this.applicantForm.$setUntouched();
    this.tempApplicant = {} as CaseMember;
    this.addEditApplicant = {} as CaseMember;
  }

  /** Get the text to display based on the ownership type selected */
  getOwnershipTypeText(): string {
    var ownershipTypeText;

    if (this.companyDetails && this.companyDetails.howWillYouOwnNewDevelopment) {
      switch (this.companyDetails.howWillYouOwnNewDevelopment) {
        case OwnNewDevelopmentEnum.UKLimitedCompany:
          ownershipTypeText = "UK Limited Company";
          break;
        case OwnNewDevelopmentEnum.OverseasLimitedCompany:
          ownershipTypeText = "Overseas Limited Company";
          break;
        case OwnNewDevelopmentEnum.PensionFund:
          ownershipTypeText = "Pension Fund";
          break;
        case OwnNewDevelopmentEnum.UKLimitedLiabilityPartnership:
          ownershipTypeText = "UK Limited Liability Partnership";
          break;
        default:
          ownershipTypeText = "";
      }
      return ownershipTypeText;
    }
    return "";
  }

  /**Determine whether to show CompanyOrPartnershipName */
  showCompanyOrPartnershipName(): boolean {
    if (
      this.companyDetails &&
      this.companyDetails.howWillYouOwnNewDevelopment != OwnNewDevelopmentEnum.PersonalNames &&
      this.companyDetails.hasTheCompanyOrPensionBeenFormedYet
    ) {
      return true;
    }
    return false;
  }

  /**Determine whether to show CompanyOrPartnershipNumber */
  showCompanyOrPartnershipNumber(): boolean {
    if (
      this.companyDetails &&
      this.companyDetails.howWillYouOwnNewDevelopment != OwnNewDevelopmentEnum.PersonalNames &&
      this.companyDetails.hasTheCompanyOrPensionBeenFormedYet
    ) {
      return true;
    }
    return false;
  }

  /**Determine whether to show PensionType */
  showPensionType(): boolean {
    if (
      this.companyDetails &&
      this.companyDetails.howWillYouOwnNewDevelopment == OwnNewDevelopmentEnum.PensionFund &&
      this.companyDetails.hasTheCompanyOrPensionBeenFormedYet
    ) {
      return true;
    }
    return false;
  }

  /** Determing whether to show the Tell us more fields */
  showTellUsMoreFields(): boolean {
    if (
      this.companyDetails &&
      this.companyDetails.howWillYouOwnNewDevelopment != OwnNewDevelopmentEnum.PersonalNames &&
      this.companyDetails.howWillYouOwnNewDevelopment != OwnNewDevelopmentEnum.Other
    ) {
      return true;
    }
    return false;
  }

  setDate(dateToUpdate: Date, month: number, year: number) {
    // Two digit years!
    var fullYear: number;
    var today = new Date();
    if (today.getFullYear() < 2000 + year) {
      // If it's after this year, we probably mean 19xx.
      fullYear = 1900 + year;
    } else {
      // Otherwise it's probably in the 2000s.
      fullYear = 2000 + year;
    }
    dateToUpdate.setUTCFullYear(fullYear);
    // Note: Months are 0 based.
    dateToUpdate.setUTCMonth(month - 1);
  }

  invite(applicant: CaseMember) {
    this.$caseMemberClient
      .inviteApplicant(applicant.uniqueRef)
      .then((i) => {
        this.modal = true;
        this.message = "Your email was successfully sent.";
      })
      .catch((error) => {
        this.modal = true;
        this.message = "there was a problem on sending the email. Please try again later.";
      });
  }

  //File upload

  //calculateFilesForThisModule() {
  //  this.fileUploadPlaning = this.fileUpload.filter(file => file.Module === ModuleEnum.Planning);
  //this.fileUploadTeam = this.fileUpload.filter(file => file.Module === ModuleEnum.ProfessionalTeam);
  //this.fileUploadProperties = this.fileUpload.filter(file => file.Module === ModuleEnum.ComparableProperties);
  //}

  calculateTotalFiles(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module === filter).length;
    }
    return this.total;
  }

  onFileSelect(files: FileAttachment[], module: ModuleEnum = this.thisModuleSection) {
    if (files.length > 0) {
      this.fileAttachmentHelper
        .UploadFileLstInSync(files, this.uploadingFiles, this.case.id, this.fileUpload, module)
        .then((result) => {
          this.openModal = false;
        });
    }
  }

  downloadFile(file: FileAttachment) {
    this.dataLoading = true;
    this.fileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  downloadFilesAsZip(files: FileAttachment) {
    var keys: string[] = [];
    for (var file in files) {
      if (files[file].FileLocation) {
        keys.push(files[file].FileLocation);
      }
    }
  }

  deleteFile(file: FileAttachment) {
    this.case.attachments.splice(this.case.attachments.indexOf(file), 1);
    this.fileAttachmentClient.markAsDeleted(file.id).then((result) => {
      // code for file upload
      //this.calculateFilesForThisModule();
    }); //remove on the server
    // this.$rootScope.$apply();
  }
  renameFile(file: FileAttachment) {
    if (this.renamingFile === undefined) {
      // if renaming this file will dirty the case, we'll want to set it back to pristine when we're done.
      // this.renamingFileDirties = !$scope.caseForm.$dirty;
      this.renamingFile = file;
    } else {
      delete this.renamingFile;
    }
  }
  renamingFileComplete(file: FileAttachment) {
    this.dataLoading = true;
    this.fileAttachmentClient
      .fileRename(file)
      .then((response) => {
        file.tempURL = response.tempURL;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  expandOrCollapse(value: boolean) {
    this.ownership = value;
    this.siteDetails = value;
    this.planning = value;
    this.procurement = value;
    this.deposit = value;
    this.guarantees = value;
    this.exitStrategy = value;
    this.completion = value;
    this.mezzanine = value;
    this.preferences = value;
    this.existingRelationships = value;
    this.caseOverview = value;
    this.executiveSummary = value;
    return value;
  }

  /**
   * Determines when to show/hide the Invite button
   * @param shareholder
   */
  showInviteButton(shareholder: CaseMember) {
    // If the shareholder has already been verified then don't show the button
    if (shareholder.isVerified) {
      return false;
    }

    // At least 2 of the security questions should be answered
    var count = 0;

    if (shareholder.phoneNumber) {
      count++;
    }

    if (shareholder.postalAddress.postCode) {
      count++;
    }

    if (shareholder.dateOfBirth) {
      count++;
    }

    if (count >= 2) {
      return true;
    }

    return false;
  }

  autoFillCaseOverview() {
    this.loanCriteria.dI_StreetAddress.addressLine1 = "10 Kings Road";
    this.loanCriteria.dI_StreetAddress.addressLine2 = "York";
    this.loanCriteria.dI_StreetAddress.addressLine3 = "";
    this.loanCriteria.dI_StreetAddress.addressLine4 = "";
    this.loanCriteria.dI_StreetAddress.postCode = "YO1 1ET";
    this.loanCriteria.dI_AreaSalesAreaResidential = 1000;
    this.case.purchaseProcessType = PurchaseProcessTypeEnum.RegularPurchase;
    this.case.planningPermissionType = PlanningPermissionTypeEnum.NoPlanning;
    this.case.planningResponsibility = PlanningResponsibilityEnum.Borrower;
    this.case.planningDescription =
      "We purchased the site with outline planning 6 months ago, with a bridging loan.We havenow dealt with all reserved matters, and have detailed planning permission for 26x 3 & 4 bed houses.";
    this.case.siteDescriptionOnCompletion = "The site will be bare land at completion.";
    this.case.buildProcurementType = BuildProcurementTypeEnum.DesignAndBuildContract;
    this.case.depositDescription =
      "50% of the deposit will come from the shareholders and 50% will come from investors. The investors are family and friends and their investment will be secured as a 2nd charge.";
    this.case.guaranteeDescription = "This is the dummy text";
    this.loanCriteria.cI_Dev_ExitStrategy = ExitStrategyEnum.PartSalePartRefinance;
    this.case.hasSetCompletionDate = true;
    const maxDate = Date.now();
    const timestamp = Math.floor(Math.random() * maxDate);
    this.case.completionDate = new Date(timestamp);
    this.loanCriteria.searchPreferenceLoanSize = 1;
    this.loanCriteria.searchPreferencePricing = 2;
    this.loanCriteria.searchPreferenceCompletionSpeed = 3;
    this.loanCriteria.searchPreferenceCustomerService = 4;
    this.companyDetails.excludedLenders = "Example Lenders";
  }
}
